// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__bLJ+R","copyright":"Footer_copyright__YfiEY"};